interface DataTablePaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export function DataTablePagination({ page, totalPages, onPageChange }: DataTablePaginationProps) {
  return (
    <div className="flex items-center justify-between mt-4 pt-3 border-t border-mono-800">
      <span className="text-xs text-mono-200 tracking-wider">
        PAGE {page} OF {totalPages}
      </span>
      <div className="flex gap-2">
        <button
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          className="px-3 py-1 text-xs tracking-wider text-mono-200 hover:text-mono-100 bg-mono-800 rounded disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
        >
          PREV
        </button>
        <button
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
          className="px-3 py-1 text-xs tracking-wider text-mono-200 hover:text-mono-100 bg-mono-800 rounded disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
        >
          NEXT
        </button>
      </div>
    </div>
  );
}
